import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_option_group_view = _resolveComponent("option-group-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: `segment-${_ctx.segment.alias}`,
    class: "additional-options"
  }, [
    (_ctx.segment.description)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          innerHTML: _ctx.decodeHtml(_ctx.segment.description)
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([[
            {'no-gutters': _ctx.columnsNoGutter},
            `row-cols-xxl-${_ctx.columns}`
        ], "row row--option-groups row-cols-1 row-cols-md-2"])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segment.optionGroups, (optionGroup) => {
        return (_openBlock(), _createBlock(_component_option_group_view, {
          key: optionGroup.id,
          "option-group": optionGroup,
          "show-price": _ctx.segment.showPrice
        }, null, 8, ["option-group", "show-price"]))
      }), 128))
    ], 2)
  ], 8, _hoisted_1))
}